import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import "./MainLayout.css"; // Add styling if needed
import NavigationBar from "./NavigationBar";
import Footer from "./Footer";
import ConnectSection from "./ConnectSection";
import { useLocation } from "react-router-dom";

const MainLayout = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isBecomeAPartnerPage = pathname.includes("/become-a-partner");
  const isContactUs = pathname.includes("/contact-us");

  const shouldShowConnectSection = () => {
    return pathname !== "/pricing" && pathname !== "/request-demo"
  }

  return (
    <div className="main-layout">
      <header>
        <NavigationBar onToggleMobileMenu={() => setIsMobileMenuOpen(!isMobileMenuOpen)} />
      </header>

      {/* Page Content */}
      <main style={{ filter: isMobileMenuOpen ? "blur(8px)" : "" }}>
        <Outlet /> {/* This is where the routed page will be rendered */}
      </main>

      {/* Footer */}
      <footer>
      {!isContactUs && !isBecomeAPartnerPage && shouldShowConnectSection()  && <ConnectSection />}
        <Footer />
      </footer>
    </div>
  );
};

export default MainLayout;
